import { Task } from '@atom/types/task';
import { UserDetail } from '@atom/types/user';
import { WorkOrderDetailType } from '@atom/types/work';
import { setDisplayDate } from '@atom/utilities/timeUtilities';

import {
  getHoursPerResource,
  getTotalOtHours,
} from './hidotOvertimeReportUtilities';
import ReportSection from './ReportSection';
import TeamTable from './TeamTable';

type TeamSectionProps = {
  workOrder: WorkOrderDetailType;
  task: Task;
  users: UserDetail[];
};

const TeamSection = ({ workOrder, task, users }: TeamSectionProps) => {
  const hoursPerResource = getHoursPerResource(task);
  const totalOtHours = getTotalOtHours(task);
  const date = setDisplayDate(workOrder?.completionDate);

  return (
    <ReportSection
      title="Team"
      value={`Hours per Resource: ${hoursPerResource} / Total OT Hours: ${totalOtHours}`}
    >
      <TeamTable users={users} hours={hoursPerResource} date={date} />
    </ReportSection>
  );
};

export default TeamSection;
